import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

/**
 * Typed replacements for the raw react-redux hooks. Always use these: the untyped versions
 * give `any` for state and lose dispatch's thunk overloads.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
